<template>
  <div >

<div class="habit-card-sub-body d-flex mx-auto" >
        <div class="card-body">
            <div class="col-12 text-center">
                <h2 >Education Management Dashboard</h2>
            </div>
            <div class="row">
                <div class="color-palette-set bordered m-2 p-4">
                    <div class="color-palette-set  bordered  m-2 p-4">
                        <div class="bg-primary color-palette px-1"><span>Manage Courses &amp; Course Assets</span> <i class="far fa-calendar-alt"></i></div>
                        <div class="bg-default disabled color-palette px-1"><span>
                            <button class="btn btn-sm bg-primary m-2" @click="createNewCourse">Create New Course <i class="fas fa-plus fai-white"></i></button>
                            </span>
                            <button class="btn btn-sm btn-warning m-2" :disabled="selcourse_id==''" @click="editCourse()">Edit Course</button>
                            <button class="btn btn-sm btn-success m-2"  :disabled="selcourse_id==''" @click="manageLessons()">Edit/Create Lessons</button>
                        </div>
                        <div v-if="coursesData.length>0">
                            <div class="row m-2" v-if="selcourse_id!= ''">Selected Course: <h6 v-html="getSelectedCourseInfo()"></h6>
                            <div><img :src="getSelectedCourseURL()"  style="max-width:100%;width:90%;"></div>

                            </div>
                            <select @change="setCourseAssets()" v-model="selcourse_id">
                                <option value="">Select a Course</option>
                                <option v-for="xcourse in coursesData" :value="xcourse.id" :key="xcourse.id">{{xcourse.name}}: ({{xcourse.byline}})</option>
                            </select>
                        </div>
                    </div>

                <div class="card text-center" v-if="selcourse_id != ''" >
                <h4>Course Categories:</h4>
                    <div class="row m-2">
                        <button :disabled="selcourse_id==''" @click="createLessonCateg()" class="btn btn-sm btn-primary">Create Course Category</button>
                        <button :disabled="selcourse_id==''" @click="manageLessons()" class="btn btn-sm btn-primary">Create Lessons</button>
                    </div>

                    <div id="displayLessonCategories" v-if="courseLessonCats.length>0" >
                        <table class="table table-striped">
                            <thead><tr><th>Name:</th><th>By-line</th><th>Order</th><th>Action</th></tr></thead>
                            <tbody>
                            <tr v-for="lessoncat in courseLessonCats" :key="lessoncat.id">
                                <td>{{lessoncat.name}}</td><td>{{lessoncat.byline}}</td><td>{{lessoncat.order_num}}</td>
                                <td>
                                    <i title="Delete" @click="doubleConfirmCategoryDelete(lessoncat.id)" class="fas fa-trash text-danger"></i>
                                    <i title="Edit" @click="editLessonCat(lessoncat.id)" class="fas fa-pen text-warning"></i>
                                    <!-- <i title="Manage Lessons" @click="manageLessons(lessoncat.id)" class="fas fa-plus text-primary"></i> -->
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                </div>

                </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import Errors from '../partials/Errors.vue';
import Swal from 'sweetalert2';
var _ = require('lodash');
import EventBus from '../../event-bus';
import { v4 as uuidv4 } from 'uuid';

export default {
    components: { Errors },
    name: "EduDashboard",
    data() {
        return {
            userdata:[],
           coursesData:[],
            errors: {
                        nahme: '',
                        message: '',
                    },
            selcourse_id:'',
            allLessonCats:[],
            courseLessonCats:[],

        }
    },
    props: {
        user:'',
        courses:'',
        lessoncats:'',
        // myfsdetails:'',
        // videolinks:''
    },
    mounted() {
        this.userdata = JSON.parse(this.user);
        this.coursesData = JSON.parse(this.courses);
        this.allLessonCats = JSON.parse(this.lessoncats);
        console.error("CoursesData length: " + this.coursesData.length);
        EventBus.$on('refreshParentPage', (data) => {
            this.getCourseData();//TODO: IS THERE ANY USE OF THIS IF WE RELOAD THE PAGE AFTER????
            document.location.reload();
        });
    },

    methods: {
        manageLessons(lessonCatID) {
            window.location.replace('/edu/admin/lessons');
        },
        deleteLessonCat(lessonCatID) {
              axios.post('/edu/lessoncat/delete/' + lessonCatID, {'course_id': this.selcourse_id})
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.courseLessonCats = JSON.parse(res.data.lessoncats);
                this.updateToast(this.message, 4000);
                console.error(res.data.message);
                EventBus.$emit('refreshParentPage');
            })
            .catch(err => {
                console.error(err);
                this.updateToast(err.message, 4000, 'error');
            })
            .finally(()=> {
                // location.reload();
            });

        },
        editLessonCat(lessoncatID) {
            var thisLessonCatData = this.getLessonCatData(lessoncatID);
            var thisCourse = this.getCourseData(this.selcourse_id);
             EventBus.$emit('editLessonCatModal', {courseName: thisCourse.name, courseID: thisCourse.id, lessonCatData: thisLessonCatData});
        },
        setCourseAssets() {
             var thisCourse = this.getCourseData(this.selcourse_id);
            //get all lessoncats for this course:
            this.courseLessonCats = this.getLessonCats(this.selcourse_id);
        },
        getLessonCats(course_id) {
            var courseLessonCats = [];
            [...this.allLessonCats].forEach(lessoncat=>{
                if(lessoncat.course_id == course_id) {
                    courseLessonCats.push(lessoncat);
                }
            });
            return courseLessonCats;
        },
        getLessonCatData(lessoncatid) {
            var lessonCat = '';
            [...this.allLessonCats].forEach(lessoncat=>{
                if(lessoncat.id == lessoncatid) {
                    lessonCat= lessoncat;
                }
            });
            return lessonCat;
        },

        createLessonCateg() {
             var thisCourse = this.getCourseData(this.selcourse_id);
            EventBus.$emit('newLessonCatModal', {courseName: thisCourse.name, courseID: thisCourse.id});
        },
        // createCourseCateg() {
        //     var thisCourse = this.getCourseData(this.selcourse_id);
        //     EventBus.$emit('showLessonCategModal', {courseName: thisCourse.name});
        // },
        createNewCourse() {
            console.error(" edudash::cr new course.");
            var payload = {};
            EventBus.$emit('showNewCourseModal');
        },
        editCourse(course_id) {
            var payload = {'course':  this.getCourseData(this.selcourse_id )};
            EventBus.$emit('editCourseModal', payload);
        },
        getCourseData(course_id) {
            //  console.error("looing for : " + course_id);
            var retVal = '';
            [...this.coursesData].forEach(course=> {
                if(course.id == course_id) {
                    // console.error("Found course...." + course.id);
                     retVal =  course;
                }
            });
            return retVal;
        },
        getSelectedCourseInfo() {
            if(this.selcourse_id != '') {
                var course = this.getCourseData(this.selcourse_id );
                return course.name + " <small>( " + course.byline + " )</small>";
            } else {
                return '';
            }
        },
        getSelectedCourseURL() {
            if(this.selcourse_id != '') {
                var course = this.getCourseData(this.selcourse_id );
                return course.image_url;
            } else {
                return '';
            }
        },
    doubleConfirmCategoryDelete(lessonCatID) {
        Swal.fire({
        title: 'Do you want to delete this Category?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Delete Category',
        denyButtonText: `Don't delte Category`,
        }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                this.deleteLessonCat(lessonCatID);
            } else if (result.isDenied) {
                Swal.fire('Category was not deleted', '', 'info')
            }
        });
    },
    updateToast(message, timer = 2000, icon='success') {
        const Toast = Swal.mixin({
            position: 'center',
            width: 500,
            showConfirmButton: true,
        });
        Toast.fire({
            icon: icon,
            title: message
        });
    },



    }


}
</script>

<style scoped>
.habit-page {
  -ms-flex-align: center;
  align-items: center;
  background: #e9ecef;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100vh;
  -ms-flex-pack: center;
  justify-content: center;
}
.habit-box {
  width: 540px;

}

.habit-card-body {
  background: #eee;
  border-top: 0;
  color: #666;
  padding: 20px;
}
.habit-card-sub-body {
    width:80%;
    border:1.5px solid #fff;
    background: rgb(230, 234, 247);
    border-top: 1em;
    margin: 4.4em;
    color: #666;
    padding: 20px;
    border-radius:4px;/*2em 2em 0em 0em;*/
    box-shadow: #ddd 4px 4px 4px;
}
.input-group{
margin-bottom:.4em;
}

.btn-container{
display:flex;
margin:1em;
}
a, button {
margin-left:auto;
}
.div-box{
margin: 2em;
padding: 2em;
border: solid 1px #fff;
box-shadow: 4px 4px 4px #666;
 border-radius:2em 2em 0em 0em;
}
.customElements{
margin: 2em;
padding: 2em;
border: solid  1px #fff;
border-radius:2em 2em 0em 0em;
box-shadow: 4px 4px 4px #666;
}
.header-box-msg, .habit-table-head{
padding:.75em;
background:#343a40;
color:#ffc107;
}
.tracker-btn{
    margin-top: .5em;
    margin-bottom: .5em;
    margin-left:1em;
    /* margin-right:1em; */
    width:80%;
    padding: .5em;
    /* align-content: center; */
}
.fai-red{
    color:rgb(129, 67, 67);
}
.fai-green{
    color:rgb(65, 131, 65);
}
.fai-blue{
    color:rgb(18, 7, 240);
}
.fai-orange{
    color:rgb(230, 111, 13);
}





.mobile-first,
.desktop-first {
  padding: 1em;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.15);
  margin: 2em auto;
  max-width: 750px;
}

/*  mobile-first */
@media (min-width: 600px) {
  .mobile-first .sales-points {
    display: flex;
    justify-content: space-between;
  }

  .mobile-first .sales-point {
    width: 30%;
  }
}

/* desktop first */
.desktop-first .sales-points {
  display: flex;
  justify-content: space-between;
}

.desktop-first .sales-point {
  width: 30%;
}

@media (max-width: 600px) {
  .desktop-first .sales-points {
    display: block;
  }

  .desktop-first .sales-point {
    width: 100%;
  }
}
.bordered{
border: .5px solid rgb(193, 191, 191);
border-radius: 4px;
padding: 82px;
margin: 2px;
background: #d9e7f4;
}





</style>
